import { createSelector } from '@reduxjs/toolkit';
import { Data } from '@taraai/types';
import { RootState } from 'reduxStore/store';

export const getUsersWithAccessLevels = createSelector(
  (state: RootState): RootState => state,
  (none: unknown, orgId: Data.Id.OrganizationId): Data.Id.OrganizationId => orgId,
  (state: RootState, orgId: Data.Id.OrganizationId) => state.usersWithAccessLevels[orgId],
);
